import {AnimalIdentifier} from "../api/generated/herd-animal";

export const animalIdentifiersAreEqual = (a: AnimalIdentifier, b: AnimalIdentifier) => a.type === b.type && a.value === b.value;